<p class="fleft lgd-jackpot-val" *ngIf="lottoId !== 48">
  <ng-container *ngIf="jackpot > 0; else pending">
    <ng-container *ngIf="currency == 'MXN'">MXN</ng-container>
    <ng-container *ngIf="currency == 'USD'">US</ng-container>
    <ng-container *ngIf="currency == 'BRL'">R</ng-container>
    <ng-container *ngIf="currency == 'AUD'">$</ng-container>
    <ng-container *ngIf="currency == 'PLN'">Z</ng-container>

    <strong class="poppins inline-block">
      <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL' || currency == 'MXN'">$</ng-container>
      <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
      <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
      <ng-container *ngIf="currency == 'AUD'">A</ng-container>
      <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
      {{jackpot}}
    </strong>

    <span class="million relative">
      <ng-container *ngIf="('lang' | translate) == 'en'">Million</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'es'">Millones</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'pt'">MILHÕES</ng-container>
      <div class="timer absolute">
        <app-countdown></app-countdown>
      </div>
    </span>
  </ng-container>
  <ng-template #pending> {{'PENDING' | translate}} </ng-template>
</p>

<ng-container *ngIf="lottoId == 48">
  <p class="fleft lgd-jackpot-val">
    <strong class="poppins inline-block">{{'USD' | translate}}</strong><br />
    <span class="claim relative"> {{'DAY' | translate }} </span>
  </p>
  <div class="timer timer-cash relative">
    <app-countdown></app-countdown>
  </div>
</ng-container>
